/**
 * practiceScope (HA-320).
 *
 * Module-level bridge between `ActivePracticeProvider` (React state) and the
 * axios request interceptor (module scope). React state can't be read from
 * inside `installSessionInterceptors`, so the provider mirrors the active
 * scope here on every change and the interceptor reads it.
 *
 * The stored value is the `?practice_id=` to send, or `null` when the
 * primary practice is selected (the backend falls back to the JWT primary,
 * so no query param is needed). Keeping the primary-vs-non-primary decision
 * in the provider keeps the interceptor a dumb reader.
 */

let currentPracticeIdScope: string | null = null;

/**
 * Set by `ActivePracticeProvider` whenever the selected practice changes.
 * Pass the practice id for a non-primary selection, or `null` for the
 * primary practice / no selection.
 */
export const setActivePracticeScope = (practiceId: string | null): void => {
  currentPracticeIdScope = practiceId;
};

/**
 * Read by the axios request interceptor. Returns the `?practice_id=` value
 * to append to GET requests, or `null` to send no scope param.
 */
export const getActivePracticeScope = (): string | null => currentPracticeIdScope;
